import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { WORKSPACES_PATH } from 'site-constants';

import { useAuthentication } from 'commons/hooks';

interface RedirectProps {
  to?: string;
}
export const Redirect = ({ to = '' }: RedirectProps) => {
  const location = useLocation();
  const { applicationSlug } = useAuthentication();
  return <Navigate to={`${WORKSPACES_PATH}/${applicationSlug}${to}${location.search}`} replace />;
};
